var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 3.34375C11.9199 3.34375 10.4473 4.25 9.59766 5.60938C8.80469 7.02539 8.80469 8.78125 9.59766 10.1406C10.4473 11.5566 11.9199 12.4062 13.5625 12.4062C15.1484 12.4062 16.6211 11.5566 17.4707 10.1406C18.2637 8.78125 18.2637 7.02539 17.4707 5.60938C16.6211 4.25 15.1484 3.34375 13.5625 3.34375ZM13.5625 15.125C10.957 15.125 8.57812 13.7656 7.27539 11.5C5.97266 9.29102 5.97266 6.51562 7.27539 4.25C8.57812 2.04102 10.957 0.625 13.5625 0.625C16.1113 0.625 18.4902 2.04102 19.793 4.25C21.0957 6.51562 21.0957 9.29102 19.793 11.5C18.4902 13.7656 16.1113 15.125 13.5625 15.125ZM6.48242 20.5625L4.55664 26.9062H22.5684L20.5859 20.5625H6.48242ZM22.625 17.8438L25.4004 26.9062L26.25 29.625H23.3613H3.70703H0.875L1.66797 26.9062L4.5 17.8438H22.625ZM35.8223 10.6504L28.5723 17.9004L27.6094 18.8633L26.6465 17.9004L23.0215 14.2754L22.0586 13.3125L23.9844 11.4434L24.9473 12.4062L27.6094 15.0684L33.8965 8.78125L34.8594 7.81836L36.7852 9.6875L35.8223 10.6504Z",
    fill: "#0962AD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUserCheck);
export default __webpack_public_path__ + "static/media/chart-user-check.af3bd5f2d2974702542f3796c257e74f.svg";
export { ForwardRef as ReactComponent };